<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import common from "@/utils/common";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "nursing",
      key: "id",
      selectC: "",
      url: {},
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "住院号",
          name: "patientId",
          value: "",
          width: "400px",
          type: "input",
          rules: [{ required: true }],
        },
        {
          label: "姓名",
          name: "patientName",
          value: "",
          width: "400px",
          type: "input",
          rules: [{ required: true }],
        },

        {
          label: '预计手术时间',
          name: 'operativeTime',
          value: '',
          type: 'date'
        },
      ],
      forms: {
      },
    };
  },
  created() {
    let query = this.$route.query;
    this.action = query.action
    this.kv = query.kv

  },
  mounted() {

  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/nursing/nusingById/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          this.forms.operativeTime = res.data.operativeTime.toString()
        }
      });
    },

    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      console.log(q)
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(
              `/admin/system/nursing`,
              q,
              this.action == 'edit' ? 'PUT' : 'POST'
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });

    },




  },
};
</script>
